import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    <div class="flex items-center justify-start text-aux-black">
      @if (params?.data?.logo) {
        <div class="mr-4 w-32">
          <img [alt]="params?.data?.name" [src]="params?.data?.logo" />
        </div>
      }
      @if (params?.data?.name) {
        <div>{{ params?.data?.name }}</div>
      }
    </div>
  `,
})
export class AgIntegrationsVendorComponent implements ICellRendererAngularComp {
  params?: ICellRendererParams;

  agInit(params: ICellRendererParams) {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }
}
